import React, { useState, useEffect } from "react";

import { UploadTO, GetTOSByDate, DeleteTOS } from "../api/TO";
import { Me } from "../api/users";

const TO = ({ token }) => {
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [file, setFile] = useState("");
  const [haveFile, setHaveFile] = useState(false);
  const [responseUpload, setResponseUpload] = useState({});
  const [user, setUser] = useState();
  const [responseTos, setResponseTos] = useState();
  const [deleteListTO, setDeleteListTo] = useState([]);

  const fetchProfile = async () => {
    try {
      const data = await Me(token);
      setUser(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  async function addFile(event) {
    setFile(event.target.files[0]);
    setHaveFile(true);
  }

  async function sendFile(event) {
    const data = await UploadTO(token, file);
    setResponseUpload(data);
  }

  async function loadTOS() {
    const data = await GetTOSByDate(
      token,
      selectedStartDate,
      selectedEndDate,
      user.restaurant_id,
    );
    setResponseTos(data);
  }

  function selectTO(id) {
    let list = deleteListTO;
    if (list.includes(id)) {
      list = list.filter((item) => item != id);
    } else {
      list.push(id);
    }
    setDeleteListTo(list);
  }

  async function deleteTOS() {
    const data = await DeleteTOS(token, deleteListTO);
    let dataTos = responseTos.filter((item) => !data.includes(item.id));
    setResponseTos(dataTos);
    setDeleteListTo([]);
  }
  return (
    <div className="container-fluid" style={{ marginTop: "5%" }}>
      <div className="accordion " id="accordionFlushExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              Добавление ТО и Чеков
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="row justify-content-center">
              <div className="col-md-12">
                <h1 className="text-center" style={{ marginTop: "5%" }}>
                  Добавление ТО и чеков
                </h1>
              </div>
              <div className="col-md-4">
                <div
                  className="form input-group"
                  style={{ marginTop: "5%", marginBottom: "15%" }}
                >
                  <input
                    className="form-control"
                    type="file"
                    id="formFile"
                    onChange={addFile}
                  ></input>
                  {haveFile && (
                    <button className="btn" onClick={sendFile}>
                      Отправить
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {!(responseUpload.success == null) && (
                <div className="col-md-6" style={{ marginTop: "2%" }}>
                  <h3 className="text-center">Загруженные строки</h3>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="text-center">id</th>
                        <th className="text-center">Дата</th>
                        <th className="text-center">ТО</th>
                        <th className="text-center">Транзакции</th>
                      </tr>
                    </thead>
                    <tbody>
                      {responseUpload.success &&
                        responseUpload.success.map((row) => (
                          <tr>
                            <td>{row.id}</td>
                            <td>{row.date}</td>
                            <td>{row.value}</td>
                            <td>{row.receipt}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
              {!(responseUpload.errors == null) && (
                <div className="col-md-6" style={{ marginTop: "2%" }}>
                  <h3 className="text-center">Проблемнные строки</h3>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="text-center">id</th>
                        <th className="text-center">Дата</th>
                        <th className="text-center">ТО</th>
                        <th className="text-center">Транзакции</th>
                        <th className="text-center">Проблема</th>
                      </tr>
                    </thead>
                    <tbody>
                      {responseUpload.errors &&
                        responseUpload.errors.map((row) => (
                          <tr>
                            <td>{row.id}</td>
                            <td>{row.date}</td>
                            <td>{row.value}</td>
                            <td>{row.receipt}</td>
                            <td>{row.message}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo"
            >
              Редактирование
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="row">
              <div className="col-md-12">
                <h1 className="text-center" style={{ marginTop: "5%" }}>
                  Удаление товарооборота и чеков
                </h1>
              </div>
              <div className="col-md-9">
                <p
                  className="text-center"
                  style={{ fontSize: "18px", marginTop: "5%" }}
                ></p>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="text-center">id</th>
                      <th className="text-center">Дата</th>
                      <th className="text-center">ТО</th>
                      <th className="text-center">Транзакции</th>
                      <th className="text-center">Удалить</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseTos &&
                      responseTos.map((row) => (
                        <tr key={row.id}>
                          <td className="text-center">{row.id}</td>
                          <td className="text-center">{row.date}</td>
                          <td className="text-center">{row.value}</td>
                          <td className="text-center">{row.receipt}</td>
                          <td className="text-center">
                            <input
                              onChange={() => selectTO(row.id)}
                              className="form-check-input"
                              type="checkbox"
                              id="checkboxNoLabel"
                              value=""
                              aria-label="..."
                            ></input>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div
                  className="delete text-center"
                  style={{ marginBottom: "5%" }}
                >
                  <button className="btn" onClick={deleteTOS}>
                    Удалить
                  </button>
                </div>
              </div>
              <div className="col-md-3">
                <div className="select-ts" style={{ marginTop: "30%" }}>
                  <input
                    className="form-control"
                    type="date"
                    value={selectedStartDate}
                    onChange={(e) => setSelectedStartDate(e.target.value)}
                    style={{ marginTop: "5%" }}
                  />
                  <input
                    className="form-control"
                    type="date"
                    value={selectedEndDate}
                    onChange={(e) => setSelectedEndDate(e.target.value)}
                    style={{ marginTop: "5%" }}
                  />
                  <div className="text-center">
                    <button
                      className="btn text-center"
                      onClick={loadTOS}
                      style={{ marginTop: "5%" }}
                    >
                      Выгрузить
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TO;
